import { Component, Input } from '@angular/core';
import { StartStatus } from '@assetaccountant/core/models/onboarding/start-status';
import { startReviews } from './reviews-config';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  standalone: false,
})
export class ReviewsComponent {
  @Input() status: StartStatus;

  get reviews() {
    if (this.status) {
      return startReviews.filter(r => r.matchingStatuses.includes(this.status));
    }
  }

  getImageUrl(fileName: string) {
    return `url("/resources/images/reviews/${fileName}.webp")`;
  }
}
